import { CabinMediaItem, CabinMediaResource } from './types'

export const toCabinMediaItems = (resources: CabinMediaResource[]): CabinMediaItem[] =>
    resources.map((resource, index) => ({
        id: `${resource.resourceUrl}-${index}`,
        src: resource.resourceUrl,
        title: resource.displayTitle,
        description: resource.displaySubTitle,
    }))
